import { render, staticRenderFns } from "./RegularField.vue?vue&type=template&id=1ce0d916&"
import script from "./RegularField.vue?vue&type=script&lang=js&"
export * from "./RegularField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports